import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderTypeAppResource
    from '@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderTypeAppResource';

class ServiceProviderEmergencyCardAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-emergency-card';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/emergencies/cards';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'title',
            'imageUuid',
            'serviceProviderTypeUuid',
            'articleSlug',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            serviceProviderType: ServiceProviderTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }

}

export default ServiceProviderEmergencyCardAppResource;
